module.exports = __webpack_public_path__ + "img/logo-training.3b0eebe1.svg";